(function () {
  'use strict';

  var updateTimer;
  var lastRequest = 0;
  var moneyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  });

  function updateBars(totalPence, itemCount) {
    document.querySelectorAll('[data-anpb-shipping-progress]').forEach(function (bar) {
      var threshold = Number(bar.getAttribute('data-threshold'));
      if (!threshold || threshold <= 0) return;

      var remaining = Math.max(0, threshold - totalPence);
      var percent = Math.min(100, Math.max(0, Math.round(totalPence * 100 / threshold)));
      var message = bar.querySelector('.anpb-shipping-progress__message');
      var progress = bar.querySelector('.anpb-shipping-progress__track');
      var fill = bar.querySelector('.anpb-shipping-progress__fill');
      if (message) {
        var wording = itemCount === 0
          ? "Free delivery on orders over " + moneyFormatter.format(threshold / 100).replace(/\.00$/, '')
          : remaining > 0
            ? "You're " + moneyFormatter.format(remaining / 100) + " away from free delivery"
            : "You've unlocked free delivery!";
        if (message.textContent.trim() !== wording) message.textContent = wording;
      }
      if (progress) progress.setAttribute('aria-valuenow', String(percent));
      if (fill) fill.style.width = String(percent) + '%';
    });
  }

  async function refresh() {
    var current = ++lastRequest;
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) return;
      var cart = await response.json();
      if (current !== lastRequest) return;
      updateBars(cart.total_price, cart.item_count);
    } catch (error) {
      /* Keep initial server rendered values if the cart request fails. */
    }
  }

  function scheduleRefresh() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(refresh, 150);
  }

  function relevantCartMutation(record) {
    var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (target && target.closest('[data-anpb-shipping-progress]')) return false;
    if (target && target.closest('#CartDrawer-CartItems, #main-cart-items, cart-items, cart-drawer-items')) return true;
    return Array.from(record.addedNodes).some(function (node) {
      if (node.nodeType !== 1) return false;
      return node.matches('#CartDrawer, #CartDrawer-CartItems, #main-cart-items, cart-items, cart-drawer-items');
    });
  }

  function init() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    }
    var observer = new MutationObserver(function (records) {
      if (records.some(relevantCartMutation)) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('cart:refresh', scheduleRefresh);
    document.addEventListener('shopify:section:load', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
